import theme from '../../layout/Theme';

const styles = (materialTheme) => ({
  itemsPadding: {
    borderBottom: `1px solid ${theme.colors.grey10}`,
    padding: '4px 0px',
    fontWeight: theme.font.weight.semibold,
    fontSize: theme.font.size.xl,
    marginTop: '30px',
  },
  restaurantNameFont: {
    padding: '4px 0px',
    fontWeight: theme.font.weight.semibold,
    fontSize: theme.font.size.xl2,
  },
  restaurantTypeFont: {
    fontSize: theme.font.size.xl,
  },
  parentCartWidth: {
    border: '1px solid lightgrey',
    borderRadius: '10px',
    marginLeft: '0px',
    overflowX: 'hidden',
    [theme.screenSize.extraLargeScreen]: {
      marginLeft: '50px',
    },
    [theme.screenSize.middleWidth]: {
      border: 'none',
    },
  },
  takeoutBackground: {
    border: '1px solid #7CD4FD',
    borderRadius: '16px',
    height: '136px',
    background: theme.colors.white12,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  takeoutHeading: {
    display: 'flex',
    justifyContent: 'center',
    color: materialTheme.palette.secondary.main,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
  },
  takeoutSubHeading: {
    padding: '0px 7%',
    color: theme.colors.blue120,
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    display: 'flex',
    justifyContent: 'center',
  },
  iconCenter: {
    display: 'flex',
    justifyContent: 'center',
    lineHeight: '24px',
  },
});

export default styles;
